import { z } from 'zod';

import { TalentSearchItemSchema } from './talent-search-item';

export const TalentSearchItemsSchema = z.object({
  alwaysShow: z.array(TalentSearchItemSchema),
  showHide: z.array(TalentSearchItemSchema),
});

export type TalentSearchItems = z.infer<typeof TalentSearchItemsSchema>;
